// extracted by mini-css-extract-plugin
export default {"btn":"Video2Btn_btn__vTcm4","text":"Video2Btn_text__2jU3R","playButton":"Video2Btn_playButton__rsuko"};